import React from "react";
import {
    Typography,
    Button,
    Grid,
    ExpansionPanel,
    ExpansionPanelSummary,
    ExpansionPanelDetails,
    Checkbox,
    IconButton,
} from "@material-ui/core";
import {
    DeleteIcon,
    PeopleIcon,
    RoomIcon,
    DownloadIcon,
    LinkIcon,
    ErrorIcon,
} from "@icarius-icons";
import { withStyles } from "@material-ui/core/styles";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { getLocalizedString } from "@icarius-localization/strings";
import { hexToRgb } from "@icarius-utils/colors";
import { HOVER_OPACITY } from "@icarius-utils/constants";
import { RESOURCES_ENDPOINT } from "@icarius-connection/endpoints";
import { previewFromURL } from "@icarius-utils/download";

const CustomExpansionPanelDetails = withStyles({
    root: {
        paddingTop: 0,
        marginRight: 33,
    },
})(ExpansionPanelDetails);

const AlertItem = (props) => {

    const {
        data,
        color,
        handleDelete,
        handleModifyStatus,
        handleOpenGridDialog,
        selectedCodes,
        handleChangeSelectedCodes,
    } = props;

    const handlePositionClick = (coordinates) => {
        if (coordinates) {
            const url = "https://www.google.com/maps/search/?api=1&query=" + coordinates.latitude + "," + coordinates.longitude;
            window.open(url, "_blank");
        }
    };

    const openLink = (url) => {
        let newUrl = url;
        if (!url.match(/^https?:\/\//i)) {
            newUrl = 'http://' + url;
        }
        window.open(newUrl, "_blank");
    };

    const CustomButton = withStyles({
        root: {
            textTransform: "none",
            backgroundColor: data.isRead ? "var(--secondaryBackgroundColor)" : "var(--genreBackground)",
            "&:hover": {
                backgroundColor: hexToRgb(color, HOVER_OPACITY),
            },
        },
    })(Button);

    const CustomExpansionPanel = withStyles({
        rounded: {
            borderRadius: "10px",
            "&:first-child": {
                borderRadius: "10px",
                marginTop: "0 !important",
            },
            "&:last-child": {
                borderRadius: "10px",
            }
        },
        root: {
            backgroundColor: !data.isRead ? "var(--secondaryBackgroundColor)" : "var(--genreBackground)",
            margin: "8px 0px",
        },
        expanded: {
            margin: "8px 0px !important",
        },
    })(ExpansionPanel);

    return (
        <CustomExpansionPanel>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                <Grid container item>
                    <Grid container item xs={11}>
                        <Grid container item xs={12} sm={6} md={2} alignItems="center">
                            <Checkbox
                                onChange={() => handleChangeSelectedCodes(data.code)}
                                checked={selectedCodes.includes(data.code)}
                            />
                            <Typography variant="subtitle1" style={{ fontWeight: 600 }} className="whiteText">
                                {data.alertClass}
                            </Typography>
                        </Grid>
                        <Grid container item sm={9} md={7} alignItems="center">
                            <Typography variant="subtitle1" className="whiteText">
                                {data.title}
                            </Typography>
                        </Grid>
                        <Grid container item xs={11} md={2} alignItems="center">
                            <Typography variant="subtitle1" className="whiteText">
                                {data.date + " " + data.time + "hrs"}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container item xs={1}>
                        <Grid container item xs={12} alignItems="center" justify="flex-end">
                            <ErrorIcon style={{ color: data.type === "A" ? "var(--ownRed)" : "transparent" }} />
                        </Grid>
                    </Grid>
                </Grid>
            </ExpansionPanelSummary>
            <CustomExpansionPanelDetails>
                <Grid container style={{ margin: '0px 10px' }}>
                    <Grid container direction="column" item xs={12}>
                        <Typography variant="subtitle1" className="whiteText" style={{ whiteSpace: "pre-wrap" }}>
                            {data.text}
                        </Typography>
                        {
                            data.references &&
                            <>
                                <Typography className={"whiteText"} variant="subtitle1" style={{ fontWeight: 800 }}>
                                    {getLocalizedString("references")}
                                </Typography>
                                <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                                    <Typography variant="body1" className="whiteText" style={{ whiteSpace: "pre-wrap" }}>
                                        {data.references}
                                    </Typography>
                                </div>
                            </>
                        }
                    </Grid>
                    <Grid container item xs={12} justify="flex-end" style={{ padding: '20px 0px' }}>
                        {
                            data.attachment &&
                            <IconButton disableRipple onClick={() => previewFromURL(RESOURCES_ENDPOINT + data.attachment)}>
                                <DownloadIcon style={{ color: "var(--mainText)" }} />
                            </IconButton>
                        }
                        {
                            data.link &&
                            <IconButton disableRipple onClick={() => openLink(data.link)}>
                                <LinkIcon style={{ color: "var(--mainText)" }} />
                            </IconButton>
                        }
                        {
                            data.coordinates &&
                            <IconButton disableRipple onClick={() => handlePositionClick(data.coordinates)}>
                                <RoomIcon style={{ color: "var(--mainText)" }} />
                            </IconButton>
                        }
                        {
                            Boolean(data?.visualizationGrid?.length) &&
                            <IconButton disableRipple onClick={() => handleOpenGridDialog(data)}>
                                <PeopleIcon style={{ color: "var(--mainText)" }} />
                            </IconButton>
                        }
                        <Grid item style={{ paddingRight: "10px" }}>
                            <IconButton disableRipple onClick={() => handleDelete(data.code)}>
                                <DeleteIcon style={{ color: "var(--mainText)" }} />
                            </IconButton>
                        </Grid>
                        <CustomButton
                            disableRipple={true}
                            className="whiteText"
                            variant={"contained"}
                            onClick={() => handleModifyStatus(data.code)}
                        >
                            {getLocalizedString(data.isRead ? "markAsUnread" : "markAsRead")}
                        </CustomButton>
                    </Grid>
                </Grid>
            </CustomExpansionPanelDetails>
        </CustomExpansionPanel>
    );
}

export default AlertItem;